<template>
  <v-container>
    <v-expansion-panels v-model="paneles">
      <!-- Como escribir un acta dialógica -->
      <WritingActa />

      <!-- Compromisos Previos -->
      <!-- <CompromisosPrevios :fecha="meetingMinute.startTime || meeting.fecha" v-if="meeting.number != 0"/> -->

      <!-- Desarrollo de la reunión -->
      <v-expansion-panel class="pa-3" outlined>
        <v-expansion-panel-title>Desarrollo de la reunión</v-expansion-panel-title>

        <v-expansion-panel-text>
          <!-- Iteramos sobre cada tema usando v-for -->
          <div v-for="(tema, index) in meetingMinute.topics" :key="index">
            <v-card>
              <v-card-title>{{ index + 1 }}. {{ tema }}</v-card-title>

              <!-- Mostrar los elementos filtrados -->
              <v-card-text  v-for="(element, elIndex) in elements.filter(el => el.topic === index + 1)" :key="elIndex">
                <ElementComponent 
                  :topic="index + 1" 
                  :element="element" 
                  @edit="editElement(element)"
                  @disagreement="disagreementEvent"
                  :mode="mode"
                />
              </v-card-text>

              <v-card-text>
                <NewElementForm :topicNumber="index + 1"/>
              </v-card-text>
            </v-card>
          </div>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>

  </v-container>

  <!-- Modal para editar elemento dialógico -->
  <EditingElement v-if="selectedElement" v-model="showEditing" :element="selectedElement"
    @cancelEditingElement="cancelEditingElement" @save="updateElement" />
</template>

<script>
import api from '@/api.js';
import EditingElement from "./EditingElement.vue";
import WritingActa from '@/components/generic/tutorials/WritingActa.vue';
// import CompromisosPrevios from './CompromisosPrevios.vue';
import ElementComponent from './ElementComponent.vue';


export default {
  name: "InMeetingComponent",
  components: {
    EditingElement,
    WritingActa,
    // CompromisosPrevios,
    ElementComponent,
  },
  props: {
    meeting: {
      type: Object,
      required: true,
    },
  },
  watch: {
    elements: {
      handler: function () {
        // console.log('se detectó un cambio en elements (watcher)', this.elements);
        this.$store.commit('setElements', this.elements);
        this.elements
      },
      deep: true
    }
  },
  computed: {
    project() {
      return this.$store.state.project || {};
    },

    meetingMinute() {
      return this.$store.state.meetingMinute || {};
    },

    useVoting() {
      return this.$store.state.project.options.useVoting || false;
    },

    email() {
      return localStorage.getItem('email') || null;
    },

    user() {
      return JSON.parse(localStorage.getItem('user')) || null;
    },

    canVote(){
      return this.project?.options?.useVoting || false;
    },

    mode(){
      return this.meeting.state || 'post-meeting';
    }
  },
  data() {
    return {
      paneles: [1],
      elements: [],

      showEditing: false,
      selectedElement: null,

      // Desacuerdo
      showDisagreement: false,
      topicDisagreement: null,
    };
  },
  methods: {
    disagreementEvent(element){
      this.showDisagreement = true;  // Mostrar el modal de desacuerdo
      this.topicDisagreement = element.topic;
    },
    initSocket() {
      // Unirse a la sala correspondiente al ID de la reunión
      this.$socket.emit("event_join", {
        room: this.meeting._id,
        user: JSON.parse(localStorage.getItem("user"))
      });

      this.$socket.on('new_element', (payload) => {
        console.log('RECIBIMOS ELEMENTOOOOO----');
        this.elements.push(payload);
      });

      // Escuchar el evento element_blocked
      this.$socket.on('element_blocked', (payload) => {
        // console.log('element_blocked - payload: ', payload);
        const { element } = payload;
        const elementIndex = this.elements.findIndex(el => el._id === element._id);
        if (elementIndex !== -1) {
          this.elements[elementIndex].blocked = true;
        }
      });

      // Escuchar el evento de element_unlocked
      this.$socket.on('element_unblocked', (payload) => {
        // console.log('element_unblocked - payload: ', payload);
        const { element } = payload;
        const elementIndex = this.elements.findIndex(el => el._id === element._id);
        if (elementIndex !== -1) {
          this.elements[elementIndex].blocked = false;
        }
      });

      this.$socket.on('element_deleted', (payload) => {
        console.log('element_deleted - payload: ', payload);
        const { element } = payload;
        const elementIndex = this.elements.findIndex(el => el._id === element._id);
        if (elementIndex !== -1) {
          this.elements.splice(elementIndex, 1);
        }
      })

      this.$socket.on('element_updated', (payload) => {
        console.log('element_updated - payload: ', payload);
        const { element } = payload;
        const elementIndex = this.elements.findIndex(el => el._id === element._id);
        if (elementIndex !== -1) {
          this.elements[elementIndex] = element;
        }
      })

      this.$socket.on("new_topic", (nuevoTema) => {
        console.log("Nuevo tema recibido:", nuevoTema);
        this.$store.commit('updateMeetingMinute', {
          topics: [...this.meetingMinute.topics, nuevoTema.topic]
        });
      });
    },
    async getElements() {
      try {
        const response = await api.get(`/api/element/meeting/${this.$route.params.meetingId}`);
        this.elements = response.data;
      } catch (e) {
        console.log(e);
      }
    },
    cancelEditingElement() {
      this.toggleElementLock(this.selectedElement, false);
      this.showEditing = false;  // Cerrar el editor
      this.selectedElement = null;  // Limpiar la selección
    },
    cancelDisagreement() {
      console.log('Cancelando desacuerdo');
      this.showDisagreement = false;  // Cerrar el editor
    },
    toggleElementLock(element, lock) {
      console.log('haciendo el toggleelementlock', lock);
      const event = lock ? 'event_block_element' : 'event_unblock_element';
      const updateData = { blocked: lock, blockedBy: lock ? localStorage.getItem('email') : null };

      this.$socket.emit(event, {
        room: this.meeting._id,
        user: localStorage.getItem('email'),
        element: element
      });

      // Mandar a backend el cambio de estado
      try {
        api.put(
          `/api/element/update/${element._id}`,
          updateData,
          { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
        );
      } catch (e) {
        console.log(e);
      }
    },
    async editElement(element) {
      if (element.blocked) {
        this.$socket.emit('event_unblock_element', {
          room: this.meeting._id,
          user: localStorage.getItem('email'),
          element: element
        });
        return;
      }

      this.selectedElement = { ...element };  // Copia del elemento a editar
      this.showEditing = true;  // Se muestra el editor

      // Mandar evento de bloquear elemento
      this.toggleElementLock(element, true);
    },
    updateElement(updatedElement) {
      // Buscar el índice del elemento en el array this.elements
      const index = this.elements.findIndex(el => el._id === updatedElement._id);

      // Si se encuentra el elemento, actualizarlo localmente
      if (index !== -1) {
        this.elements[index] = updatedElement;
      }

      // Actualizar para el resto de usuarios
      this.updateElementBackend(updatedElement);  // Emite el evento en ws y se actualiza la bd
      this.selectedElement = null;  // Vacía la variable para edición de elemento
      this.showEditing = false;  // Cierra el editor
    },
    async updateElementBackend(element) {
      // Emitir evento de elemento actualizado
      this.$socket.emit('event_update_element', {
        room: this.$route.params.meetingId,
        user: localStorage.getItem('email'),
        element: element
      });

      // Actualizar el elemento en la base de datos
      try {
        const response = await api.put(`/api/element/update/${element._id}`,element);
        if(response.status === 200 || response.status === 201){
          this.$store.commit('setSnackbar', { text: 'Elemento actualizado correctamente', color: 'success', icon: 'mdi-check' });
        }
      } catch (e) {
        console.log(e);
        this.$store.commit('setSnackbar', { text: 'Error al actualizar el elemento', color: 'error', icon: 'mdi-alert' });
      }
    },

    // Función que obtenga el correo del autor del elemento dialógico
    async getWriter(id) {
      if(!id) {
        return null;  // Si no hay ID, retornar null
      }
      
      try {
        const response = await api.get(`/api/user/perfil/${id}`);
        if (response.data) {
          return response.data.email;
        }
      } catch (e) {
        console.log(e);
      }
    },

    // Función generada para obtener los tópicos con sus elementos asociados, para que sea usada en ProjectMeetingView.vue
    // en la generación del documento PDF.
    async getTopicsWithElementsAsync() {
      const topicPromises = this.meetingMinute.topics.map(async (topic, index) => {
        const elementsForTopic = this.elements.filter(el => el.topic === index + 1);

        const associatedElements = await Promise.all(elementsForTopic.map(async (el, elIndex) => {
          const cleanedDescription = el.description.replace(
            /^(compromiso|acuerdo|desacuerdo|duda|texto libre|votaci[oó]n):\s*/i,
            ''
          );
          const autor = await this.getWriter(el.writer);
          const votos = [el.si, el.no];

          return {
            index: `${index + 1}.${elIndex + 1}`,
            description: cleanedDescription,
            type: el.type,
            autor,
            votos,
          };
        }));

        return {
          topicTitle: topic,
          elements: associatedElements,
        };
      });

      return Promise.all(topicPromises);
    }


  },
  created() {
    this.getElements();
    this.initSocket();
  },
  beforeUnmount() {
    // Desconectar el socket al salir del componente
    this.$socket.off("new_element");
    this.$socket.off("element_blocked");
    this.$socket.off("element_unblocked");
    this.$socket.off("element_deleted");
    this.$socket.off("element_updated");
    this.$socket.off("new_topic");
  },

};
</script>

<style scoped>
</style>
